import React from "react";
import Layout from "./Layout";
import Booking from "./Booking";

const Reservations = () => {
  return (
    <div>
      <h1>
        <Booking />
      </h1>
    </div>
  );
};

export default Reservations;
